export default __webpack_public_path__ + "static/media/illustration-trees-2.d31d2169.svg";